import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SignatureDocumentStatusEnum, documentStatusTextMap } from '../../models/signature-request.dict';

@Component({
  selector: 'signature-request-document-status-badge',
  standalone: true,
  imports: [],
  templateUrl: './signature-request-document-status-badge.component.html',
  styleUrls: ['./signature-request-document-status-badge.component.scss']
})
export class  SignatureRequestDocumentStatusBadgeComponent implements OnInit, OnChanges{
  @Input() status: SignatureDocumentStatusEnum;

  public statusText: string;

  ngOnInit(): void {
    this.setStatusText();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['status']) {
      this.setStatusText();
    }
  }

  private setStatusText(): void {
    const statusText = documentStatusTextMap[this.status];
    this.statusText = statusText;
  }

}
